import React, { useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ProcessList from "./ProcessList";
import ChangePassword from "../../common/ChangePassword";
import ToolbarAccount from "../../admin_portal/ToolbarAccount";
import Fab from "@mui/material/Fab";
import AddIcon from '@mui/icons-material/Add';
import MobileSearch from "../home/MobileSearch";
import Search from "../home/Search";
import { TextField, Autocomplete, Chip, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import BusinessIcon from '@mui/icons-material/Business';
import { addSearchFilter, removeSearchFilter, clearSearchFilters } from "../../../store/job/jobSlice";
import { useDispatch, useSelector } from 'react-redux';
import { Tabs, Tab, FormControl, Select, MenuItem, Tooltip } from '@mui/material';
import {
  get_company_process,
  get_company_process_stage,
  setCompany,
  setProcessHasJobForm,
  setProcessTab
} from '../../../store/user/userSlice';
import { isAuth } from '../../../helpers/cookies';
import { setJobData } from '../../../store/job/jobSlice';
import { useNavigate } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import { setFavicon } from "../../../helpers/faviconUtils";



const BaseLayout = (props) => {
  const {
    modules,
    ChildComponent,
    company_process,
    company_process_stage,
    selected_process_tab,
    selected_stage_tab,
    selected_company,
    change_password,
    handleChangePasswordOpen,
    is_open,
    company_details
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user_company } = useSelector((state) => state.user);

  const handleChangePassword = () => {
    handleChangePasswordOpen(!is_open);
  };

  const handleProcessTabChange = (event, newValue) => {
    let company_id = selected_company ? selected_company : isAuth().company_id;
    let params = {
      company_id,
      process_id: newValue
    }
    dispatch(get_company_process_stage(params));
    dispatch(setProcessTab(newValue));
    dispatch(setProcessHasJobForm(newValue));
    dispatch(setJobData({}));
  };

  const handleCompanyChange = (event) => {
    const { value } = event.target;
    let company_id = value ? value : isAuth().company_id;
    dispatch(setCompany(value));
    dispatch(get_company_process(company_id));
  };




  const displayLogo = company_details?.company_logo;

  useEffect(() => {
    if (displayLogo) {
      setFavicon(displayLogo);
    }
  }, [displayLogo]);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: 'column', position: 'relative', height: '100%' }}>
        <AppBar
          elevation={1}
          position="sticky"
          sx={{
            minHeight: '82px',
            px: 0,
            zIndex: "999!important",
            background: '#fff',
            justifyContent: 'center'
          }}>
          <Container maxWidth={false} disableGutters>
            <Toolbar disableGutters sx={{
              justifyContent: 'space-between',
              alignItems: 'stretch'
            }}>
              <Box component='a' href="/" sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                pl: 2,
                width: 210,
                minWidth: 210,
                mr: 0,
                height: 'auto'
              }}>
                <img
                  src={displayLogo}
                  alt='logo.png'
                  style={{
                    width: "11rem",
                    height: "auto",
                    objectFit: 'contain'
                  }}
                />
              </Box>

              <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-start', maxWidth: '600px', pl: 3, mt: 2 }}>
                <Search onSearchSubmit={() => {
                  if (location.pathname !== '/customer/portal/dashboard') {
                    navigate('/customer/portal/dashboard');
                  }
                }} />
              </Box>

              <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2, flex: 1, justifyContent: 'center' }}>
                {company_process.length > 1 && (
                  <Tabs
                    value={selected_process_tab || false}
                    onChange={handleProcessTabChange}
                    sx={{
                      "& .MuiTabs-indicator": {
                        backgroundColor: '#f57c00',
                        height: '3px'
                      },
                      "& .MuiTab-root": {
                        color: '#aaa',
                        // fontWeight: 600,
                        fontSize: '16px',
                        fontFamily: "'Inter Tight', sans-serif",
                        '&.Mui-selected': {
                          color: '#f57c00'
                        }
                      }
                    }}
                  >
                    {company_process.map((process, idx) => (
                      <Tab
                        key={idx}
                        label={process.name.toUpperCase()}
                        value={process.id}
                        disabled={window.location.pathname === '/create-job'}
                      />
                    ))}
                  </Tabs>
                )}
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, pr: 4 }}>

                {/* <FormControl variant="standard" sx={{ minWidth: 240 }}>
                  <Select
                    value={selected_company || ""}
                    onChange={handleCompanyChange}
                    displayEmpty
                    disableUnderline
                    renderValue={(selected) => {
                      let label = "Acme Promotional Products";
                      if (selected === "option1") label = "Option 1";
                      else if (selected === "option2") label = "Option 2";

                      return (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <BusinessIcon sx={{ color: '#757575', fontSize: 20 }} />
                          <span>{label}</span>
                        </Box>
                      );
                    }}
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      color: '#444'
                    }}
                  >
                    <MenuItem value="">
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <BusinessIcon sx={{ color: '#757575', fontSize: 20 }} />
                        <span>Acme Promotional Products</span>
                      </Box>
                    </MenuItem>
                    <MenuItem value="option1">
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <BusinessIcon sx={{ color: '#757575', fontSize: 20 }} />
                        <span>Option 1</span>
                      </Box>
                    </MenuItem>
                    <MenuItem value="option2">
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <BusinessIcon sx={{ color: '#757575', fontSize: 20 }} />
                        <span>Option 2</span>
                      </Box>
                    </MenuItem>
                  </Select>
                </FormControl> */}

                <ToolbarAccount />
              </Box>
            </Toolbar>
          </Container>

        </AppBar>

        <Container maxWidth={false} disableGutters sx={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#FFF5F2',
        }}>
          <ProcessList
            company_process={company_process}
            company_process_stage={company_process_stage}
            selected_process_tab={selected_process_tab}
            selected_stage_tab={selected_stage_tab}
            selected_company={selected_company}
            ChildComponent={ChildComponent}
          />
          <Fab color="primary" aria-label="add" sx={{
            display: { md: 'none', xs: 'flex' },
            position: 'absolute',
            bottom: 20,
            right: 40
          }}>
            <AddIcon />
          </Fab>
        </Container>

        {/* change password modal */}
        <ChangePassword
          change_password={change_password}
          handleChangePassword={handleChangePassword}
          open={is_open}
        />
        <MobileSearch />
      </Box>
    </>
  );
};

export default BaseLayout;